import { render, staticRenderFns } from "./AnnotatedImage.vue?vue&type=template&id=7f88fd2b&scoped=true"
import script from "./AnnotatedImage.vue?vue&type=script&lang=js"
export * from "./AnnotatedImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f88fd2b",
  null
  
)

export default component.exports